import styled from 'styled-components';

export const LoadingStyled = styled.div`
  position: fixed;
  inset: 0;
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  .theme_standard_loading {
    width: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    svg {
      display: block;
      margin: 0 auto;
    }
  }
  .bg_loading_message {
    width: 100%;
    margin-top: 16px;
    color: #fff;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
  }
`;
